import { getBrandContext } from '../brand';
import { BRAND_CODES } from '../brand/constants';

/**
 * Placeholder used in URL templates to mark where the domain token is injected.
 * Example: 'https://cim.test.{domain}.com/...'
 */
export const DOMAIN_PLACEHOLDER = '{domain}';

/**
 * Resolves the domain token for use in URL templates.
 *
 * Rules:
 * - HealthSpring → 'healthspring'  (single centralised domain, no state)
 * - BCBS         → 'bcbs{stateCode}' e.g. 'bcbsil', 'bcbstx'
 *
 * The token replaces the `{domain}` placeholder in env-var URL templates so
 * that one template covers every brand/state without duplicate env vars.
 */
export const resolveDomainToken = (): string => {
  const { brandCode } = getBrandContext();

  if (brandCode === BRAND_CODES.HEALTHSPRING) {
    return 'healthspring';
  }

  // BCBS: derive the state code from the hostname.
  // Hostname examples: paymentportal-dev.test.bcbsil.com → stateCode = 'il'
  const href =
    typeof window !== 'undefined' && window.location
      ? window.location.href
      : '';
  const afterBcbs = href.includes('bcbs') ? href.split('bcbs')[1] : 'il';
  const stateCode = afterBcbs.split('.')[0].toLowerCase();

  return `bcbs${stateCode}`;
};
